<template lang="html">
  <div class="headerPanelMobileMenu row my-3">
    <div class="profileContainerMobileMenu">
      <div class="profileImgMobileMenu"/>
      <span class="profileNameMobileMenu">
        {{ username }}<br/>
      </span>
    </div>
    <div class="closePanelMobileMenu close-panel">
      <f7-icon class="imgClosePanelMobileMenu close-panel" :icon="isWhite()"></f7-icon>
    </div>
  </div>
</template>

<script>
import design from '@/design/design.json'

export default {
  name: 'MobileIdentityHeader',
  props: {
    username: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      design: design.menu
    }
  },
  methods: {
    isWhite () {
      if (this.design.headbandColor.length >= 7) {
        var c = this.design.headbandColor.substring(1)
        var rgb = parseInt(c, 16)
        var r = (rgb >> 16) & 0xff
        var g = (rgb >> 8) & 0xff
        var b = (rgb >> 0) & 0xff

        var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b

        if (luma < 40) {
          return 'icon-cross_white'
        } else {
          return 'icon-cross'
        }
      }
      return 'icon-cross'
    }
  }
}
</script>